const TOKEN_KEY = process.env.NEXT_PUBLIC_SESSION_KEY;

export const getAuthToken = () => {
  return localStorage.getItem(TOKEN_KEY);
};

export const setAuthToken = (token) => {
  localStorage.setItem(TOKEN_KEY, token);
};

export const clearAuthToken = () => {
  localStorage.removeItem(TOKEN_KEY);
  window.dispatchEvent(new Event("user:logout"));
};
